import { render, staticRenderFns } from "./itemCreate.vue?vue&type=template&id=cb958ca6&scoped=true&lang=html&"
import script from "./itemCreate.vue?vue&type=script&lang=js&"
export * from "./itemCreate.vue?vue&type=script&lang=js&"
import style0 from "./itemCreate.vue?vue&type=style&index=0&id=cb958ca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb958ca6",
  null
  
)

export default component.exports